<template>
  <page-header-wrapper><a-card :bordered="false">
    <h3>商城服务说明</h3>
    <a-alert message="DK、ODM 商城各分国内版与国际版，共四份服务说明独立保存；客户端按商城和版本展示。支持文字排版、图片和链接。" type="info" show-icon style="margin-bottom:16px" />
    <a-tabs :active-key="mallType" @change="changeMall"><a-tab-pane key="dk" tab="DK 商城" :disabled="saving" /><a-tab-pane key="odm" tab="ODM 商城" :disabled="saving" /></a-tabs>
    <a-radio-group :value="region" button-style="solid" :disabled="saving" style="margin-bottom:16px" @change="e=>changeRegion(e.target.value)"><a-radio-button value="domestic">国内版</a-radio-button><a-radio-button value="international">国际版 / International</a-radio-button></a-radio-group>
    <a-spin :spinning="loading">
      <editor v-if="loaded" :key="mallType+'-'+region" v-model="content" :height="440" :image-size="5" />
      <a-alert v-if="error" type="error" :message="error" show-icon><a slot="action" @click="load">重试</a></a-alert>
      <a-button type="primary" v-hasPermi="['dkmall:mall-service:edit']" :loading="saving" :disabled="!loaded || loading" style="margin-top:16px" @click="save">保存 {{ mallType === 'dk' ? 'DK' : 'ODM' }} 商城{{ region === 'domestic' ? '国内版' : '国际版' }}服务说明</a-button>
    </a-spin>
  </a-card></page-header-wrapper>
</template>
<script>
import Editor from '@/components/Editor'
import request from '@/utils/request'
const url='/dkmall/content-settings/mall-service-description'
export default {
  name:'MallServiceDescription',components:{Editor},
  data:()=>({mallType:'dk',region:'domestic',content:'',savedContent:'',loading:false,loaded:false,saving:false,error:'',requestId:0}),
  created(){this.load()},
  beforeDestroy(){this.requestId++},
  methods:{
    changeMall(type){
      if(this.saving||type===this.mallType)return
      const change=()=>{this.mallType=type;return this.load()}
      if(this.loaded&&this.content!==this.savedContent)return this.$confirm({title:'当前商城的修改尚未保存，确认切换？',content:'切换后未保存的修改将被放弃。',onOk:change})
      return change()
    },
    changeRegion(region){
      if(this.saving||region===this.region)return
      const change=()=>{this.region=region;return this.load()}
      if(this.loaded&&this.content!==this.savedContent)return this.$confirm({title:'当前版本的修改尚未保存，确认切换？',content:'切换后未保存的修改将被放弃。',onOk:change})
      return change()
    },
    load(){
      const id=++this.requestId;this.loading=true;this.loaded=false;this.error='';const mallType=this.mallType,region=this.region
      return request({url,method:'get',params:{mallType,region}}).then(response=>{
        if(id!==this.requestId)return
        this.content=(response.data||{}).content||'';this.savedContent=this.content;this.loaded=true
      }).catch(()=>{if(id===this.requestId)this.error='服务说明加载失败，请重试。'}).finally(()=>{if(id===this.requestId)this.loading=false})
    },
    save(){
      if(!this.loaded||this.loading||this.saving)return
      const content=this.content,mallType=this.mallType,region=this.region;this.saving=true
      return request({url,method:'put',data:{mallType,region,content}}).then(()=>{this.savedContent=content;this.$message.success(`${mallType==='dk'?'DK':'ODM'} 商城${region==='domestic'?'国内版':'国际版'}服务说明已保存`)}).finally(()=>{this.saving=false})
    }
  }
}
</script>
